import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.white,
  h1Color: colors.black,
  h2Color: colors.black,
  paraColor: colors.brightRed,
  anchorColor: colors.red
};
export default richText;